import { css } from '@emotion/react';
import { bpoints } from '../../Utils';

export function adminPanelCSS() {
    return css`
        .tabPanel {
            .p-tabview-nav-container a {
                color: #23b56e !important;
                border-color: #23b56e !important;
            }
        }

        .TextInput {
            background-color: transparent;
            border-radius: 17px;
            border-color: #34C6F1;
            border-width: 1.5px;
            width: 100%;
            padding: 1rem 1.4rem;

            font-family: 'Neue Haas Grotesk Display Pro' !important;
            font-size: calc(0.2rem + 0.7vw);
            font-style: normal;
            font-weight: 600;
            letter-spacing: 0.46px;
            color: black;

            @media (max-width: ${bpoints.tablet.w}px) {
                font-size: calc(0.8rem + 1vw);
            }

            ::placeholder {
                font-weight: 500;
                color: #A7A9AC;
            }
        }
        .containerBtn {
            width: 100%;
            display: flex;

            @media (max-width: ${bpoints.mobile.w}px) {
                flex-direction: column;

                .ButtonContainer {
                    width: 100%;

                    // .Blue {
                    //   width: 100% !important;
                    // }
                    // .Green {
                    //   width: 100% !important;
                    // }
                }
            }

        .Button {
            background: red;

            font-size: calc(0.4rem + 0.7vw);
            position: relative;
            cursor: pointer;
            border-radius: 25px;
            display: flex;
            justify-content: center;
            align-items: center;

            padding: 1rem 0;

            flex-basis: 0;
            flex-grow: 1;

            //transition: 300ms;
                @media (max-width: ${bpoints.mobile.w}px) {
                    font-size: calc(0.9rem + 0.9vw);
            }
        }

        .Green {
            background-color: #22ec9a;
            color: white;

            border-radius: 17px !important;
            border: unset !important;
            &:hover {
                background-color: #2ad690;
            }
            }
            .Blue {
            background-color: #32b8df;
            color: white;

            border-radius: 17px !important;
            border: unset !important;
            &:hover {
                background-color: #2da5c8;
            }
        }
        
}
             .shadowCard {
             background: red;
      margin-top: 1rem;
      height: 1.2rem;
      border-radius: 467px;
      background: radial-gradient(
        50.94% 44.66% at 49.86% 50.14%,
        rgba(0, 0, 0, 0.14) 0%,
        rgba(217, 217, 217, 0) 100%
      );
    }

        

        .Green {
            background-color: #22ec9a;
            border-color: #22ec9a;
            &:hover {
                background-color: #2ad690;
            }
        }

        .Button {
            display: inline-block;
            outline: none;
            cursor: pointer;
            font-size: 14px;
            line-height: 20px;
            font-weight: 600;
            border-radius: 8px;
            padding: 10px 18px;
            border: none !important;
            transition: box-shadow 0.2s ease, transform 0.1s ease;
            background: #fff;
            color: #222222;

            &:hover {
                border: none !important;
                background: #f7f7f7;
            }
        }
        .ButtonWithShadow{
                    display: flex;
                    flex-direction: column;
                    width: 50%;
                    gap: 2rem;
                    margin : 0 auto;


                    @media (max-width: ${bpoints.mobile.w}px){
                        place-self: center;
                        width: 90%;

                        button{
                            width: 100%;
                            font-size: calc(1rem + 1vw);
                        }
                    }

                    .Shadow{
                        width: 100%;
                        height: 55px;
                        border-radius: 467px;
                        background: radial-gradient(50.94% 44.66% at 49.86% 50.14%, rgba(0, 0, 0, 0.14) 0%, rgba(217, 217, 217, 0.00) 100%);
                    }
        }
    `;
}
